import * as moment from "moment";
import {TransactionEventApiDto} from "../../../api/model/rest";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import TransactionEvent, {TransactionEventTypeEnum} from "./TransactionEvent";
import {none, option, Option} from "ts-option";

/**
 * Transaction - payment received event model.
 */
export default class TransactionPaymentReceivedEvent extends TransactionEvent {
	/**
	 * @param {string} id identifier of event.
	 * @param {TransactionEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} creator entity which created the event.
	 * @param {moment.Moment} creationDateTime creation date of event.
	 * @param {Option<TransactionEventData>} data additional data for this event.
	 */
	constructor(public readonly id: string,
		public readonly type: TransactionEventTypeEnum,
		public readonly creator: AuthenticatedEntity,
		public readonly creationDateTime: moment.Moment,
		public readonly data: Option<TransactionEventData>) {
		super(id, type, creator, creationDateTime);
	}

	public static fromJson(json: TransactionEventApiDto): TransactionPaymentReceivedEvent {
		const creator = AuthenticatedEntity.fromJson(json.creator);
		const data = json.data ? option(TransactionEventData.fromJson(json.data)) : none;
		return new TransactionPaymentReceivedEvent(json.id, TransactionEventTypeEnum.PaymentReceived, creator,
			moment(json.creationDateTime), data);
	}

	getIcon() {
		return Icon.Finance;
	}

	getActivityType(): string {
		return `RECONCILED`;
	}

	getActivityMessage(): string {
		const paymentId = this.data.map(d => d.stripePaymentId);
		return `Payment ${paymentId.map(id => `ID ${id} `).getOrElse("")}received`;
	}
}

export class TransactionEventData {
	constructor(public readonly stripePaymentId: string) {}

	public static fromJson(json: { stripePaymentId: string }): TransactionEventData {
		return new TransactionEventData(json.stripePaymentId);
	}
}
